import Button from "components/v2/Button/Button";
import { useState, useRef, useEffect } from "react";
import ReactHtmlParser from "react-html-parser";

type ExpandableTextProps = {
  content: string;
  maxLines?: number;
  className?: string;
  showMoreText?: string;
  showLessText?: string;
};

function ExpandableText({
  content,
  maxLines = 10,
  className = "",
  showMoreText = "Show more",
  showLessText = "Show less",
}: ExpandableTextProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [shouldShowToggle, setShouldShowToggle] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      const lineHeight = parseInt(window.getComputedStyle(contentRef.current).lineHeight);
      const maxHeight = lineHeight * maxLines;
      const actualHeight = contentRef.current.scrollHeight;

      setShouldShowToggle(actualHeight > maxHeight);
    }
  }, [content, maxLines]);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={className}>
      <div
        ref={contentRef}
        className={`text-sm text-primary ${!isExpanded && shouldShowToggle ? "overflow-hidden" : ""}`}
        style={{
          ...(shouldShowToggle &&
            !isExpanded && {
              display: "-webkit-box",
              WebkitLineClamp: maxLines,
              WebkitBoxOrient: "vertical" as const,
              lineHeight: "1.4",
            }),
        }}
      >
        {ReactHtmlParser(content)}
      </div>
      {shouldShowToggle && (
        <Button size="sm" variant="link-color" label={isExpanded ? showLessText : showMoreText} onClick={toggleExpanded} />
      )}
    </div>
  );
}

export default ExpandableText;

ExpandableText.defaultProps = {
  maxLines: 10,
  className: "",
  showMoreText: "Show more",
  showLessText: "Show less",
};
